module.exports = __webpack_public_path__ + "static/media/loading-spinner-switch-2x.ba3df73c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/ui/common/rebranding/assets/loading-spinner-switch-2x.gif
// module id = 1437
// module chunks = 147